const CONTINUITY_OF_SERVICE = {
    EVENTS: {
        event: 'Continue with Mineral Continuity Button Click',
        eventProperties: {
            description: 'Continue with Mineral Continuity Guide Button Click',
        },
    },
};

export default CONTINUITY_OF_SERVICE;
